import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NetworkSearchComponent from './network_search';

const DrawerNav = ({ openConversationCreator, setSearchResults }) => {

  const handleSearchChange = tokens => {
    setSearchResults(tokens.map(t => t.value), tokens.map(t => t.label));
  }

  return (
    <section className="inbox-drawer-nav">
      <div className="row gutters-sm-down mb-10">
        <span className="t1 w3">Messages</span>
      </div>
      <div className="row gutters-sm-down mb-15">
        <div className="search-container">
          <NetworkSearchComponent onTokenChange={handleSearchChange} />
        </div>
      </div>
    </section>
  );
};

DrawerNav.propTypes = {
  openConversationCreator: PropTypes.func.isRequired
};

export default DrawerNav;
